import { render } from "./TheSettings.vue?vue&type=template&id=1c6e03f7&scoped=true"
import script from "./TheSettings.vue?vue&type=script&lang=js"
export * from "./TheSettings.vue?vue&type=script&lang=js"

import "./TheSettings.vue?vue&type=style&index=0&id=1c6e03f7&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6e03f7"]])

export default __exports__